let cartDrawer = document.querySelector("cart-drawer");
async function isAnyVariantInCart(variantIds) {
    try {
        let response = await fetch("/cart.js");
        let cart = await response.json();

        // Check if any of the given variant IDs exist in the cart
        return cart.items.some(item => variantIds.includes(item.id));
    } catch (error) {
        console.error("Error fetching cart data:", error);
        return false;
    }
}

async function addToCart(variantId, quantity = 1) {
    let restrictedVariants = [53314094039331, 53314094072099, 53314094104867, 53314094137635]; // Replace with actual variant IDs
    let variantExists = await isAnyVariantInCart(restrictedVariants);

    if (variantExists) {
        alert("One of these variants is already in your cart. You can't add another.");
        return;
    }

    try {
        let response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ 
              id: variantId, 
              quantity: quantity,
              sections: cartDrawer
              .getSectionsToRender()
              .map((section) => section.id),
              sections_url: window.location.pathname})
        });

        if (response.ok) {
            let data = await response.json(); // Get response data
            cartDrawer.renderContents(data);
            cartDrawer.classList.remove("is-empty");
            setTimeout(() => {
              cartDrawer.open();
              // addCar.setAttribute("disabled", "disabled")
            }, 750);
        } else {
            alert("Failed to add product. Try again.");
        }
    } catch (error) {
        console.error("Error adding product to cart:", error);
    }
}

// Example: Trigger add to cart when clicking a button
document.querySelector("#addCar").addEventListener("click", async function () {
    let variantID = document.querySelector(".hideThis").querySelector(".product-variant-id").value;
    let selectedVariantId = variantID; // Replace with the currently selected variant ID
    await addToCart(selectedVariantId);
});

